import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const VanFleet: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m76.35 508.83h447.93v30h-447.93z' />
    <path d='m180 658.83h240v30h-240z' />
    <path d='m165 780h-105v-90h30v60h75c8.13 0 15-5.25 15-11.47v-54.7h30v54.7c0 22.87-20.19 41.47-45 41.47z' />
    <path d='m540 780h-105c-24.81 0-45-18.6-45-41.47v-54.7h30v54.7c0 6.22 6.87 11.47 15 11.47h75v-60h30z' />
    <path d='m540 694.41h-30v-178.09l-27.71-154.3c-.48-1.19-1.4-2.02-2.29-2.02h-360c-.83 0-1.7.73-2.2 1.81l-27.8 154.51v178.09h-30v-180.77l28.66-159.3.28-.89c4.37-14.03 16.85-23.46 31.06-23.46h360c14.35 0 27.22 9.97 31.3 24.25l.21.72.13.74 28.36 157.93v180.76z' />
    <path d='m420 613.83h-240s0-30 0-30h210c16.57 0 30 13.43 30 30z' />
    <path d='m30 570v-90s-30 0-30 0v60c0 16.57 13.43 30 30 30z' />
    <path d='m210 240v-90s-30 0-30 0v60c0 16.57 13.43 30 30 30z' />
    <path d='m570 570v-90s30 0 30 0v60c0 16.57-13.43 30-30 30z' />
    <path d='m750 240v-90s30 0 30 0v60c0 16.57-13.43 30-30 30z' />
    <path d='m256.35 178.83h447.93v30h-447.93z' />
    <path d='m540 330h60v30h-60z' />
    <path d='m720 450h-105c-24.81 0-45-18.6-45-41.47v-54.7h30v54.7c0 6.22 6.87 11.47 15 11.47h75v-60h30z' />
    <path d='m720 364.41h-30v-178.09l-27.71-154.3c-.48-1.19-1.4-2.02-2.29-2.02h-360c-.83 0-1.7.73-2.2 1.81l-27.8 154.51v113.68h-30v-116.35l28.66-159.3.28-.89c4.37-14.03 16.85-23.46 31.06-23.46h360c14.35 0 27.22 9.97 31.3 24.25l.21.72.13.74 28.36 157.93v180.76z' />
    <path d='m600 285h-240s0-30 0-30h210c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

VanFleet.displayName = 'VanFleet';

export default VanFleet;
